import React from 'react';
import { ExternalLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.css';

const SectionHostMaybe = props => {
  const { projectInformation } = props;

  const content =
    projectInformation.projectWebsite !== '' ? (
      <>
        <div className={css.line} />

        <h2 className={css.featuresTitle}>
          <FormattedMessage id="ListingPage.donateTitle" />
        </h2>
        <div className={css.extras}>
        <img
          src={require('../../assets/icons/Donate.webp')}
          width="130px"
          style={{ paddingRight: '30px' }}
          alt=""
          ></img>
        <div className={css.contentWrappers2}>
          <FormattedMessage id="ListingPage.donateText1" />
          <span style={{ color: '#4A4A4A' }}>{projectInformation.projectTitle}</span>
          <FormattedMessage id="ListingPage.donateText2" />
        </div>
        </div>
        <div className={css.heroButton}>
          <ExternalLink href={projectInformation.projectWebsite}>
            {/* <FormattedMessage id="ListingPage.donateAction1" />
            {projectInformation.projectTitle}
            <FormattedMessage id="ListingPage.donateAction2" /> */}
            <FormattedMessage id="ListingPage.donateAction3" />
          </ExternalLink>
        </div>
      </>
    ) : null;

  return (
    <div id="host" className={css.sectionHost}>
      {content}
    </div>
  );
};

export default SectionHostMaybe;
